import { useQuery } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { analyticsKeys } from '../analytics.keys';
import { getClaimedQuests } from '../analytics.service';
import { FiveMinutes, InitialRetryDelay } from '../constants';
export const useClaimedQuests = ({ subdomain = getSubdomain(), status, startDate, endDate, interval, ...options }) => {
    const q = useQuery({
        refetchInterval: query => (!query.state.data?.isComputed ? InitialRetryDelay : false),
        ...options,
        queryKey: analyticsKeys.claimedQuests(subdomain, status, startDate, endDate, interval),
        queryFn: () => getClaimedQuests(subdomain, status, startDate, endDate, interval),
        staleTime: FiveMinutes,
    });
    return { ...q, isPending: q.isPending || !q.data?.isComputed };
};
